/**
 * Banco de ítems JK-Core — Ventas / vendedor de piso (200 ítems).
 * instrumentId: JK_SALES_RETAIL
 * Respuestas: VERDADERO / FALSO / NO SÉ
 */

import bankData from './jkSalesRetailBank.json';

export interface JKSalesRetailItem {
  id: string;
  correctAnswer: 'V' | 'F';
  text: string;
}

export const JK_SALES_RETAIL_ID = 'JK_SALES_RETAIL' as const;

export const JK_SALES_RETAIL_BANK: JKSalesRetailItem[] = bankData as JKSalesRetailItem[];

/** Selecciona n ítems aleatorios sin repetición. */
export function pickRandomJKSalesRetailItems(count: number): JKSalesRetailItem[] {
  const shuffled = [...JK_SALES_RETAIL_BANK].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
